module.exports = __webpack_public_path__ + "img/var_02_base1.50c7040b.png";